module.exports = __webpack_public_path__ + "images/signal_1.bed2ea6120f3f870d2d1a956728c4264.png";